import React, { useState, useCallback } from 'react';
// import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import BambooHrApiLogSearchParams from './BambooHrApiLogSearchParams';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import BambooHrApiLogService from '../../../Services/BambooHrApiLogService';
import BambooHrApiLogItem from './BambooHrApiLogItem';

const BambooHrApiLogAdmin = (props) => {
  const [orderBy] = useState('Id');
  const [orderDirection] = useState(OrderDirectionsEnum.Desc);
  const [searchItem, setSearchItem] = useState(new BambooHrApiLogSearchParams());

  const startSearch = useCallback((searchItem) => {
    setSearchItem(searchItem);
  }, []);

  const refresh = useCallback(() => {
    setSearchItem({ ...searchItem });
  }, [searchItem]);

  return (
    <div className='contentwrapper'>
      <TabOfDataTable
        type={BambooHrApiLogItem}
        serviceFunction={BambooHrApiLogService.GetListBySearching}
        convertDBItemsFunction={BambooHrApiLogService.ConvertDBItems}
        orderDirection={orderDirection}
        orderBy={orderBy}
        searchItem={searchItem}
        showSearchStrip={true}
        searchParamsType={BambooHrApiLogSearchParams}
        clickOnStartSearch={startSearch}
        singleSearchLine={true}
        singleSearchLinePlaceholder='Search in id, type or result...'
        errorCode='BALA51'
      />
    </div>
  );
};

export default BambooHrApiLogAdmin;
